module.exports = __webpack_public_path__ + "img/cartNull.14cd8d14.png";